import { Database } from "@punchup/data/supabase.types";
import { createClientComponentClient } from "@punchup/data/supabase/client";

export type UserComedianFollow =
  Database["public"]["Tables"]["user_comedian_follows"]["Row"];

/**
 * Fetches all comedian follows for the authenticated user
 * @returns Array of user_comedian_follows rows
 */
export async function getUserComedianFollows(): Promise<UserComedianFollow[]> {
  const supabase = createClientComponentClient<Database>({});

  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (!session?.user) {
    return [];
  }

  const { data, error } = await supabase
    .from("user_comedian_follows")
    .select("*")
    .eq("user_id", session.user.id);

  if (error) {
    console.error("Error fetching user comedian follows:", error);
    throw error;
  }

  return data || [];
}

/**
 * Fetches all comedian follows for a specific user by ID
 * Requires appropriate permissions to view another user's follows
 * @param userId - The user ID to fetch follows for
 * @returns Array of user_comedian_follows rows
 */
export async function getUserComedianFollowsById(
  userId: string
): Promise<UserComedianFollow[]> {
  const supabase = createClientComponentClient<Database>({});

  const { data, error } = await supabase
    .from("user_comedian_follows")
    .select("*")
    .eq("user_id", userId);

  if (error) {
    console.error("Error fetching user comedian follows:", error);
    throw error;
  }

  return data || [];
}
